export const VERSION = {
  number: '1.53',
  deployDate: new Date('2026-09-05')
};

export enum Role {
  User = 'User',
  Admin = 'Admin',
  SuperAdmin = 'Super_admin',
  Maintainer = 'Maintainer'
}

export enum DarkModes {
  DARK = '0',
  LIGHT = '1',
  BROWSER = '2'
}

export enum SettingsTabsNames {
  PROFILE = 'profile',
  NOMENCLATURE = 'nomenclature',
  BTI = 'bti',
  DUTIES = 'duties',
  DECLARATION = 'declaration',
  CUSTOMSBASE = 'customsbase',
  REG_MON = 'reg_mon',
  NOTIFICATIONS = 'notifications'
}

export enum ObjectType {
  SEARCH_FOLDER = 'search-folder',
  TELEDECLARATION = 'teledeclaration'
}

export enum SSOState {
  DISABLED = 'disabled',
  ENABLED = 'enabled',
  MANDATORY = 'mandatory'
}

export enum CurrentVersions {
  SearchFolders = 4
}

// More info on the statuses: https://www.douane.gouv.fr/sites/default/files/uploads/files/douane/EDI/Delta-G/Delta-C_guide_xml.pdf

export enum EnhancedInputType {
  EMAIL = 'email',
  DATE = 'date',
  DATETIME = 'datetime',
  DATETIME_LOCAL = 'datetime-local',
  NUMBER = 'number',
  PASSWORD = 'password',
  TEXT = 'text',
  TIME = 'time',
  NOMENCLATURE = 'nomenclature',
  TEXTNUMBER = 'textnumber'
}

export interface Section {
  id: string;
  title: string;
  sections: Section[];
  icon: string;
}

